module.exports = {
	Common: require('./Common/'),
	Modules: require('./Modules/')
};


// WEBPACK FOOTER //
// ./src/components/index.js